import { AssignApproverPage } from "../../modules/assign-approver"

interface AssignApproverProps {
  sidebarOpen?: boolean
}

export default function AssignApprover({ sidebarOpen }: AssignApproverProps) {
  return <AssignApproverPage />
}
